
import React from 'react';
import {Button} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";
import cards from './cards.js';


const useStyles = makeStyles((theme) => ({
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    cardMedia: {
        height:160,
        width:280,
      paddingTop: '56.25%', // 16:9
    },
    cardContent: {
      flexGrow: 1,
    },
    footer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(6),
    },
    head:{
        display: 'inline-block',
        paddingTop: 0,
        paddingRight:12,
        paddingBottom:0,
        paddingLeft:12,
        color: '#555555',
        marginBottom: 20,
        marginLeft:30,
        letterSpacing: 5,
        fontSize: 11,
    },
    box:{
        margin:15,
        marginTop: 40,
    },
    heading:{
        paddingTop: 0,
        paddingRight:12,
        paddingBottom:0,
        paddingLeft:12,
        fontSize: 18,
        fontWeight: 700,
        marginLeft:30,
        textTransform: 'uppercase',
        letterSpacing: 5,
        lineHeight: 1.8,
    }
  }));
  
 


function Projects() {
    const classes= useStyles();
    
  return (
    <main>
    {/* Hero unit */}
    <div className={classes.heroContent}>

      <div className={classes.head} id="projects">
                <ScrollAnimation offset={0} animateIn="fadeInLeft" duration={2.4} animateOnce={true} initiallyVisible={true}>
                    <span className={classes.head}>PROJECTS</span>
                    <h2 className={classes.heading}>Here are Some of My React Projects</h2>
                 </ScrollAnimation>
        </div>
        {/* <div className={classes.heroButtons}>
          <Grid container spacing={3} justifyContent="center">
            <Grid item>
              <Button variant="contained" color="primary">
                Main call to action
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary">
                Secondary action
              </Button>
            </Grid>
          </Grid>
        </div> */}
    </div>
    <Container className={classes.cardGrid} maxWidth="md">
      {/* End hero unit */}
      <Grid container spacing={4}>
        {cards.map((card) => (
          <Grid item key={card.id} xs={12} sm={6} md={4}>
            <Card className={classes.card}>
              <CardMedia
                className={classes.cardMedia}
                image={card.url}
                title={card.title}
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h5" component="h2">
                  {card.title}
                </Typography>
                
              </CardContent>
              <CardActions>
                <Button size="small" color="primary">
                  <a href={card.netlify}> View Project </a>
                  
                </Button>
                <Button size="small" color="primary">
                  <a href={card.github} >Source Code </a>
                  
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  </main>
  )
}

export default Projects








